<mat-toolbar color='primary' id="header" class="cyToolbar">
    <mat-toolbar-row>             
	    <span class="logo">
	        <h1 style="color: white;">Cypher System</h1>
	    </span>
	    <span style="font-size:10px;margin-left:5px; color: white;">Version: {{'VERSION' | env}}</span>
	    <span class="header-spacer"></span>
    </mat-toolbar-row>                 
</mat-toolbar>

